import React from 'react';

import { Checkbox } from '@flixbus/honeycomb-react';

import { RRO_WARNING_TEXT } from './texts';

import styles from './styles.module.css';

const RroWarningBanner = ({ acknowledged, onChange }) => {
	return (
		<div className={styles.rroWarningBox}>
			<strong className={styles.rroWarningTitle}>{RRO_WARNING_TEXT.title}</strong>
			<p className={styles.rroWarningText}>{RRO_WARNING_TEXT.message}</p>
			<Checkbox
				id="rro-acknowledge"
				label={RRO_WARNING_TEXT.checkboxLabel}
				checked={acknowledged}
				onChange={onChange}
			/>
		</div>
	);
};

export default RroWarningBanner;
